import Autosuggest from 'react-autosuggest';
import React from 'react';
import { connect } from 'react-redux';

import { setSearch } from '../../actions/doaAction';
import removeImg from '../../images/remove.png';
import util from '../../functions/Utilities';

class FormSuggestTopic extends React.Component {
    state = {
        suggestions: []
    };

    componentDidMount() {
        this.list = [];
    }

    countDot(text) {
        var count = text.split('.').length
        return count - 1
    }

    getSuggestions = value => {
        const inputValue = value.trim().toLowerCase();
        const inputLength = inputValue.length;
        // if (this.props.action === 'query') {
        //     return inputLength === 0 ? [] : this.list.filter(item =>
        //         item.TopicTitle.toLowerCase().includes(inputValue) && !item.TopicNo.includes('.')
        //     );
        // }
        return inputLength === 0 ? [] : this.list.filter(item =>
            item.TopicTitle.toLowerCase().includes(inputValue) && this.countDot(item.TopicNo) <= 1
        );
    };

    getSuggestionValue = suggestion => {
        this.props.handleSelect(suggestion);
        return `${suggestion.TopicNo + ". " + suggestion.TopicTitle}`;
    }

    renderSuggestion = suggestion => (
        <div>
            <h5 style={{ opacity: '0.6' }}>{`${suggestion.SubjectTitle} (${suggestion.SubjectTypeTitle})`}</h5>
            <h3>{`${util.replaceAll(suggestion.TopicNo + '. ' + suggestion.TopicTitle, '<br/>', '')}`}</h3>
        </div>
    );

    onChange = (event, { newValue }) => {
        this.props.setSearch(newValue);
        if (event.target.defaultValue && (event.target.defaultValue.length - newValue.length === 1 || newValue.length - event.target.defaultValue.length === 1)) {
            this.props.handleSelect('keyChange');

        } else if (newValue.length === 0) {
            this.props.handleSelect();
        }
    };

    onSuggestionsFetchRequested = ({ value }) => {
        this.list = this.props.topicList.filter(item => item.SubjectTypeTitle === this.props.type);
        this.setState({ suggestions: this.getSuggestions(value) });
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    onReset = () => {
        this.props.setSearch('');
        this.props.handleSelect();
    }

    render() {
        const { suggestions } = this.state;

        const inputProps = {
            placeholder: this.props.placeholder,
            value: this.props.search,
            onChange: this.onChange,
            disabled: this.props.action === 'query' && Object.entries(this.props.queryBook).length === 0 && this.props.queryBook.constructor === Object
        };

        return (
            <div className="flex-v mt-16">
                <div className="flex-container-horizontal" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                    <div className="flex-container-horizontal flex-center">
                        <h4>{this.props.name} :</h4>
                    </div>
                </div>
                <div className="flex-h">
                    <div className="flex-1">
                        <Autosuggest
                            suggestions={suggestions}
                            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                            getSuggestionValue={this.getSuggestionValue}
                            renderSuggestion={this.renderSuggestion}
                            inputProps={inputProps}
                        />
                    </div>
                    <div onClick={() => this.onReset()} className="flex-v flex-center pl-16">
                        <img src={removeImg} alt="" style={{ width: '25px', cursor: 'pointer' }} />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        topicList: state.doa.topicList,
        type: state.doa.type,
        search: state.doa.search,
        action: state.doa.action,
        queryTopicList: state.doa.queryTopicList,
        queryBook: state.doa.queryBook
    }
}
export default connect(mapStateToProps, {
    setSearch
})(FormSuggestTopic);